var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

export default function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/querySelectorAll.js
// module id = 1207
// module chunks = 0